export default [
  {
    title: 'Dashboard ',
    icon: 'PieChartIcon',
    tagVariant: 'light-warning',
    route: 'dashboard-analytics',
    resource: 'Dashboard',
    action: 'read',
  },
  {
    title: 'Home',
    icon: 'PieChartIcon',
    tagVariant: 'light-warning',
    route: 'talent-home',
    resource: 'TalentHome',
    action: 'read',
  },
  {
    title: 'Dashboards',
    icon: 'PieChartIcon',
    tagVariant: 'light-warning',
    route: 'partner-home',
    resource: 'PartnerHome',
    action: 'read',
  },
]
